import React, { FC, useState } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import { uninstallTile } from 'actions/gallery';

import { ModalImageContainerWithText } from '../ImageContainer/ModalImageContainer';
import App from '../../../models/app';
import theme from '../../../themes';
import Icon from '../Icon';

import dots from '../../../inline-icons/tile-dots.png';
import deleteIcon from '../../../inline-icons/delete-icon.png';

import { UninstallTileModal } from '../StateManagementButton/modals/UninstallTileModal';
import { TooFewTilesModal } from '../StateManagementButton/modals/TooFewTilesModal';

import { DEVICE_RENAME } from 'config';
import { minTileNumber } from '../../../constants';

const RENAME: any = DEVICE_RENAME;

type ReduxProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;
interface TileCardProps extends ReduxProps {
  tile: App;
  tileCount: number;
}

const Container = styled.div`
  display: flex;
  padding: 15px 15px 15px 5px;

  border-bottom: 1px solid ${theme.borderColor};
`;


const Content = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const ButtonContainer = styled.div`
  display: flex;
`;

const StyledIcon = styled(Icon)`
  margin: 6px;
`;

const mapStateToProps = (state: any) => {
  const deviceName = state.registry.currentUser.device?.productName?.toLowerCase();
  return {
    deviceName: RENAME[deviceName] || deviceName
  }
};

const mapDispatchToProps = (dispatch: any) => ({
  removeTile: (tileId: string) => dispatch(uninstallTile(tileId)),
});

const TileCard: FC<TileCardProps> = ({
  tile,
  removeTile,
  deviceName,
  tileCount
}) => {

  const [ state, updateState ] = useState({ showModal: false, loading: false });

  const onCancel = () => {
    updateState({...state, showModal: false })
  }

  const onSuccess = async () => {
    await updateState({...state, loading: true })
    await removeTile(tile.id)
    await updateState({...state, showModal: false, loading: false })
  }

  const renderRemoveModal = () => (
    tileCount > minTileNumber ? (
      <UninstallTileModal
        app={tile}
        onCancel={onCancel}
        onSuccess={onSuccess}
        loading={state.loading}
      />
    ) : (
      <TooFewTilesModal
        app={tile}
        onCancel={onCancel}
        onSuccess={() => {}}
        loading={state.loading}
      />
    )
  )

  const showModal = () => {
    updateState({...state, showModal: true })
  }

  return (
    <Container>
      <Content>
        <ModalImageContainerWithText
          app={tile}
          text={tile.name}
          subtext={`${tile.name} by ${tile.developer.name}`}
          deviceName={deviceName}
        />
        <ButtonContainer>
          <StyledIcon
            id={`tile-dots-${tile.id}`}
            aria-label={`tile-dots-${tile.id}`}
            url={dots}
            width={20}
            height={20}
          />
          <StyledIcon
            id={`tile-delete-${tile.id}`}
            aria-label={`tile-delete-${tile.id}`}
            url={deleteIcon}
            width={20}
            height={20}
            onClick={() => showModal()}
          />
        </ButtonContainer>
      </Content>
      { state.showModal && renderRemoveModal() }
    </Container>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(TileCard);
